import { createContext, useState } from "react";
import { DepreciationType, GeneralAssetType, MaintenanceType, ProfilAssetType, useAssetById, useDataUsage } from "../utils";
import { useParams } from "react-router-dom";



export interface actionTab {
    value?: "general" | "profile" | "depreciation" | "maintenance" | "picture" | "usage" | "histori";
    isDisabled?: boolean;
    editMode?: boolean;
    editModeProfile?: boolean;
    editModeDepreciation?: boolean;
    editModeMaintenance?: boolean;
}

type PictureListType = {
    pictures: {
        asset_picture_id: string,
        asset_picture_name: string,
        asset_picture_code: string,
        description: string,
        path_picture: string
    }[]
}

type HistoriType = {
    history: {
        month: number,
        year: number,
        transaction_date: string,
        depreciation_expenses: number
    }[]
}

type DataAssetType = GeneralAssetType & ProfilAssetType & DepreciationType & MaintenanceType & PictureListType & HistoriType

interface FormDataContextType {
    activeTab: actionTab,
    dataAsset: DataAssetType | null
    assetId: number | null
    dataUsage: ReturnType<typeof useDataUsage>["data"]
    setActiveTab: React.Dispatch<React.SetStateAction<actionTab>>
    setAssetId: (id: number) => void
    refecth: () => void,
    refecthUsage: () => void
}

const defaultTabState: actionTab = {
    value: "profile",
    editMode: false,
    editModeProfile: false,
    editModeDepreciation: false,
    editModeMaintenance: false
};


// context
export const FormDataContext = createContext<FormDataContextType>({
    activeTab: defaultTabState,
    assetId: null,
    dataAsset: null,
    dataUsage: null,

    setActiveTab: () => { },
    setAssetId: () => { },
    refecth: () => { },
    refecthUsage: () => { }
});

// context provider
export const FormDataProvider = ({ children }: { children: React.ReactNode }) => {
    const [activeTab, setActiveTab] = useState<actionTab>(defaultTabState);
    const { asset_id } = useParams();
    

    const [assetId, setAssetId] = useState<number | null>(null);

    const { data, refecth } = useAssetById({ asset_id: Number(assetId ?? asset_id) })
    
    const { data: dataUsage, refecth: refecthUsage } = useDataUsage({ assetId: Number(data?.asset_id ?? asset_id) })

    return (
        <FormDataContext.Provider value={{
            activeTab,
            dataAsset: data,
            assetId,
            dataUsage,

            setActiveTab,
            setAssetId,
            refecth,
            refecthUsage
        }}>
            {children}
        </FormDataContext.Provider>
    );
};
